module.exports = __webpack_public_path__ + "img/icon_bms2.27fa81e9.jpg";